'use strict';

import { get, set, debounce, cloneDeep, isEqual } from 'lodash';
var he = require('he');

var React = require('react');
var ComponentFactory = require('../../infrastructure/ComponentFactory');

var ComponentActionsCreator = require('../../actions/ComponentActionsCreator');

var PropertyMetadata = require('../../models/PropertyMetadata');
var ComponentInstance = require('../../models/ComponentInstance');

/** @module TextInput
 * @requires he
 * @requires react
 * @requires ComponentFactory
 * @requires ComponentActionsCreator
 * @requires PropertyMetadata
 * @requires ComponentInstance
 * @requires lodash
 */
var TextInput = ComponentFactory.Create({
	displayName: "TextInput",
	propTypes: {
		property: React.PropTypes.instanceOf(PropertyMetadata).isRequired,
		component: React.PropTypes.instanceOf(ComponentInstance).isRequired
	},

	/**
	 * @method componentDidMount
	 */
	componentDidMount: function(props) {
		this.componentDidUpdate();

		this._debouncedSave = debounce(this._save, 100, this);
	},

	/**
	 * @method componentDidUpdate
	 */
	componentDidUpdate: function(prevProps, prevState) {
		var name = this.props.property.name,
			path = ['component', 'context', name];

		var isStateChanged = !this._equal(this.state, prevState, 'value');
		var isPropertyChanged = !this._equal(this.props, prevProps, path);
		var isSynced = this._equal(this.state, this.props, 'value', path);
		if (isSynced) return;

		if (isPropertyChanged) {
			this.setState({ value: get(this.props, path) });
		} else if(isStateChanged) {
			this._debouncedSave();
		}
	},

	/**
	 * @method _save
	 */
	_save: function() {
		var component = cloneDeep(this.props.component);
		var encodedText = he.encode(get(this.state, 'value', ''));
		set(component, ['context', this.props.property.name], encodedText);

		ComponentActionsCreator.updateComponentInstanceContext(component);
	},

	/**
	 * @method _equal
	 */
	_equal: function(first, second, firstpath, secondpath) {
		secondpath = secondpath || firstpath;
		return isEqual(get(first, firstpath), get(second, secondpath));
	},

	/**
	 * @method _onTextChange
	 */
	_onTextChange: function(e) {
		this.setState({ value: e.target.value });
	},

	/**
	 * @method render
	 */
	render: function() {
		var decodedText = he.decode(get(this.state, 'value', '') + '');
		return (<div className="text-input row">
			<div className="columns input-label">
				<label className="left inline">
					<span className="small-heading">{this.props.property.description}</span>
				</label>
			</div>
			<div className="columns input">
				<input
					className="small-input"
					type='text'
					value={decodedText}
					placeholder={this.props.property.description}
					onChange={this._onTextChange} />
			</div>
		</div>);
	}
});

module.exports = TextInput;
